export enum AuthForm {
  Email = "Email",
  CreateAccount = "CreateAccount",
  Login = "Login",
  ResetPassword = "ResetPassword",
  JoinWaitlist = "JoinWaitlist",
}
